import { getUser, checkUser, deleteUser } from "../../data/dataApi";
import ContentWrapper from "../../views/components/ContentWrapper";
import ConfirmationModal from "../../views/components/ConfirmationModal";
import { useEffect, useState, useRef } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { roles } from "../../views/helpers";
import { Button } from "react-bootstrap";
import { useUserState } from "../../views/components/UserStateProvider";

const SingleUser = () => {
    const { userCapabilities } = useUserState();

    const [user, setUser] = useState();
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [unexpectedError, setUnexpectedError] = useState();
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const idRef = useRef();

    useEffect(() => {
        (async () => {
            const response = await getUser(id);
            const userResponse = await checkUser();

            idRef.current = userResponse.id;
                        
            if(response.success) {
                setUser(response.data.rows[0]);
            }
        })();
    }, [id]);

    const handleDeleteUser = async () => {
        const response = await deleteUser(id);

        if(!response.success) {
            setShowConfirmationModal(false);
            setUnexpectedError(response.error.message);
        }

        return response.success;
    };

    return (
        <>
            <ContentWrapper className="scrollable">
                <div className="back-wrapper">
                    <button className="dashboard-tertiary-btn"
                        onClick={() => {
                            if (location.key === 'default') {
                                navigate('/dashboard/user-accounts')
                            } else {
                                navigate(-1)
                            }
                        }}>
                        Back
                    </button>
                </div>
                <div className="wrapper tif-bg-color-tertiary tif-bg-light-color-white">
                    {
                        user &&
                        <div className="table-wrapper tif-mb-md-40 tif-mb-20">
                            <table className="secondary-table w-100">
                                <tbody className="secondary-body">
                                    <tr>
                                        <td><b>Name</b></td>
                                        <td>{ user.name }</td>
                                    </tr>
                                    <tr>
                                        <td><b>Email</b></td>
                                        <td>{ user.email }</td>
                                    </tr>
                                    <tr>
                                        <td><b>Role</b></td>
                                        <td>{ roles[user.role] }</td>
                                    </tr>
                                    {
                                        idRef.current === user.id &&
                                        <tr>
                                            <td><b>Password</b></td>
                                            <td><Link to={`/dashboard/user-accounts/change-password`} className="link-out">Change Password</Link></td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                    { userCapabilities.includes("delete_user") && <Button className="dashboard-quarternary-btn" onClick={() => setShowConfirmationModal(true)}>Delete User</Button> }
                </div>
            </ContentWrapper>
            <ConfirmationModal
                show={ showConfirmationModal }
                changeVisibility={ setShowConfirmationModal }
                type="delete"
                confirmationButton="Delete User"
                confirmationMessage="Are you sure you want to delete this user?"
                successMessage="User has been successfully deleted."
                modalFunction={ handleDeleteUser }
                close={
                    <Button className="dashboard-tertiary-btn" onClick={() => setShowConfirmationModal(false)}>Back to User</Button>
                }
                closeConfirmation={
                    <Link to="/dashboard/user-accounts" className="dashboard-tertiary-btn">Back to User Accounts</Link>
                }
                error={ unexpectedError }
            />
        </>
    );
}

export default SingleUser;